<template>
  <BlockUI v-if="getLoading">
    <ThuxSpinner />
  </BlockUI>
</template>

<script>
import Vue from 'vue'
import BlockUI from 'vue-blockui'
import ThuxSpinner from './ThuxSpinner'

Vue.use(BlockUI)

export default {
  components: { ThuxSpinner },
  props: {
    loading: undefined
  },
  computed: {
    getLoading () {
      return this.$store.getters.loading
    }
  }
}
</script>
